(() => {
  if (window.sdVisualPages) return;
  window.sdVisualPages = true;
  const initialized = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const init = root => {
    root.querySelectorAll('[data-sdv-quiz]').forEach(quiz => {
      if (initialized.has(quiz)) return;
      initialized.add(quiz);
      const form = quiz.querySelector('[data-quiz-form]');
      const fields = [...quiz.querySelectorAll('[data-step]')];
      const next = quiz.querySelector('[data-next]');
      const back = quiz.querySelector('[data-back]');
      const results = quiz.querySelector('[data-results]');
      const error = quiz.querySelector('[data-quiz-error]');
      let step = 0;
      const update = () => {
        fields.forEach((field, i) => field.hidden = i !== step);
        back.disabled = step === 0;
        next.textContent = step === 2 ? next.dataset.resultText : next.dataset.nextText;
        quiz.querySelector('[data-current-step]').textContent = step + 1;
        quiz.querySelector('.sdv-progress > span').style.width = `${(step + 1) / 3 * 100}%`;
        error.hidden = true;
      };
      next.addEventListener('click', () => {
        if (!fields[step].querySelector('input:checked')) {
          error.hidden = false;
          fields[step].querySelector('input').focus();
          return;
        }
        if (step < 2) {
          step++;
          update();
          fields[step].querySelector('input').focus();
          return;
        }
        const answers = Object.fromEntries(new FormData(form));
        quiz.querySelectorAll('[data-result-family]').forEach(group => group.hidden = group.dataset.resultFamily !== answers.family);
        const group = [...quiz.querySelectorAll('[data-result-family]')].find(g => g.dataset.resultFamily === answers.family);
        const candidates = [...group.querySelectorAll('[data-result-product]')];
        const preferences = {doux:['caractere:doux','caractere:cremeux','caractere:poudre','famille:muscs'],gourmand:['caractere:gourmand','note:vanille','note:caramel','note:accord-gourmand'],epice:['note:cannelle','note:poivre-noir','note:oud','famille:boises']};
        const score = card => {
          const tags = card.dataset.tags.split('|');
          let points = preferences[answers.mood].filter(t => tags.includes(t)).length * 2;
          if (answers.occasion === 'quotidien' && (tags.includes('famille:frais') || tags.includes('caractere:doux'))) points++;
          if (answers.occasion === 'soiree' && (tags.includes('famille:ambres') || tags.includes('famille:boises'))) points++;
          return points;
        };
        candidates.sort((a,b) => score(b) - score(a)).forEach((card,i) => {card.hidden = i >= 3;group.querySelector('.sdv-result-grid').append(card);});
        const labels = [...form.querySelectorAll('input:checked')].map(input => input.dataset.label);
        quiz.querySelector('[data-profile]').textContent = labels.join(' · ');
        quiz.querySelector('[data-occasion-copy]').textContent = quiz.dataset['occasion' + answers.occasion];
        form.hidden = true;
        quiz.querySelector('[data-step-label]').hidden = true;
        quiz.querySelector('.sdv-progress').hidden = true;
        results.hidden = false;
        results.focus({preventScroll:true});
        results.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
      });
      back.addEventListener('click', () => {step = Math.max(0,step - 1);update();fields[step].querySelector('input').focus();});
      form.addEventListener('submit', event => {event.preventDefault();next.click();});
      quiz.querySelector('[data-restart]').addEventListener('click', () => {form.reset();step=0;results.hidden=true;form.hidden=false;quiz.querySelector('[data-step-label]').hidden=false;quiz.querySelector('.sdv-progress').hidden=false;update();fields[0].querySelector('input').focus();});
      update();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (!reduced.matches && entry.target.animate) entry.target.animate([{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.65,.3,1)',fill:'backwards'});
      }),{threshold:.08});
      root.querySelectorAll('.sdv-enter').forEach(el => {if(!initialized.has(el)){initialized.add(el);observer.observe(el);}});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
